// Failed video generatsiyalarni avtomatik davom ettirish — barcha sozlamalar shu yerda.

export const MODES = { OFF: 'off', DRY: 'dry', ON: 'on' };
export const DEFAULT_MODE = MODES.OFF;

export const STORAGE_KEYS = {
  mode: 'ui_auto_continue_mode', // "off" | "dry" | "on"
  attempts: 'ui_auto_continue_attempts', // { [taskId]: { count, lastAt, dryAt, skip } } — count faqat ma'lumot uchun
  log: 'ui_auto_continue_log', // [{ at, taskId, mode, action, reason, error }] — oxirgi 50 ta
  lease: 'ui_auto_continue_lease', // navigator.locks bo'lmaganda zaxira belgi
};

// Bir xil tab ichidagi o'zgarishlar uchun (storage hodisasi faqat boshqa tablarga keladi)
export const CHANGE_EVENT = 'ui-auto-continue-change';

export const FAILED_STATUS = 'failed';
export const WINDOW_MS = 6 * 60 * 60 * 1000; // faqat oxirgi 6 soat ichida failed bo'lganlar
// Urinishlar soni cheklanmagan: failed_at yoki oxirgi urinishdan (qaysi biri keyinroq) shuncha vaqt o'tgach
export const RETRY_INTERVAL_MS = 60 * 1000;
export const WARN_EVERY = 10; // har 10, 20, 30... urinishda bir martalik ogohlantirish (to'xtatmaydi)
export const POLL_MS = 60 * 1000;
export const PAGE_LIMIT = 50;
export const MAX_PAGES = 3;
export const JITTER_MAX_MS = 20 * 1000; // turli brauzerlar bir vaqtda urinmasligi uchun
export const LOG_LIMIT = 50;
export const LOCK_NAME = 'iifa-auto-continue';
export const LEASE_MS = 2 * 60 * 1000;

// Qayta urinish foydasiz bo'lgan xato sabablari (error matnida qidiriladi, katta-kichik harf farqsiz).
// Hozircha taxminiy ro'yxat — haqiqiy error namunalari bilan aniqlashtiriladi.
export const NON_RETRYABLE_ERROR_PATTERNS = [
  { label: 'kredit / to\'lov', pattern: /credit|quota|balance|insufficient|payment|\b402\b/i },
  { label: 'avtorizatsiya', pattern: /\b401\b|\b403\b|unauthori[sz]ed|forbidden|api[ _-]?key/i },
  { label: "noto'g'ri ma'lumot", pattern: /\b400\b|\b404\b|\b422\b|validation|invalid|empty|not found|no pages/i },
  { label: 'kontent siyosati', pattern: /policy|moderation/i },
];
